import {FormikErrors} from 'formik';
import {builderFieldsType} from '../CreateBuilder/builderFields';

export const annuityValidator = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  if (!values.annuity?.sourceId) {
    errors.annuity = 'Please select a source';
  }
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const annuityValues = values.annuity;
  if (!annuityValues) {
    errors.annuity = 'Fill in fields';
    return errors;
  }

  return errors;
};
